export const option = {
  height: "auto",
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  selection: false,
  viewBtn: false,
  dialogType: "drawer",
  dialogClickModal: false,
  column: [
    {
      label: "所属代理商",
      prop: "deptId",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: "订单编号",
      prop: "businessCode",
      search: true,
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      search: false,
    },

    // {
    //     label: "订单编号",
    //     prop: "businessCode",
    //     search: false,
    //     display: true,
    // },
    {
      label: "租赁人",
      prop: "name",
      search: true,
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      search: false,
    },
    {
      label: "租赁金额",
      prop: "lendingAmount",
    },

    {
      label: "跟投金额",
      prop: "followInvestmentAmount",
    },
    {
      label: "起租日",
      prop: "commencementDate",
      search: false,
    },
    {
      label: "当前期数",
      prop: "currentTenancy",
    },
    {
      label: "释放金额",
      prop: "releaseAmount",
    },
    {
      label: "未释放金额",
      prop: "noReleaseAmount",
    },
    {
      label: "订单结清状态",
      prop: "settleStatus",
      display: false,
    },
    {
      label: "状态",
      prop: "types",
      search: true,
      // searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      display: false,
      hide: true,
      type: "select",
      dicData: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "已结清",
          value: 1,
        },
        {
          label: "未结清",
          value: 2,
        },
      ],
    },
    // {
    //     label: "状态",
    //     prop: "followFlagStr",
    // },
    {
      label: "所属代理商",
      prop: "businessDeptIdString",
      search: false,
      type: "select",
      display: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
  ],
};
